import get from 'lodash/get';

/**
 * Default app scroll-restoration for react-router
 */
export const defaultScrollRestoration = (args?: any) => {
  // eslint:disable-next-line:no-invalid-this
  if ( get(this, 'state.location.action') === 'PUSH'){
    window.scrollTo(0, 0);
  }
};

export const scrollToTopExceptInternal = (next: any) => {  
  if (!window){
    return;
  }
  const isInternal = get(next, 'location.state.internal') === true;
  const isBackFwd = get(next, 'location.action') === 'POP';
  const shouldScroll = !isInternal && !isBackFwd;
  shouldScroll && window.scrollTo(0, 0);
};

export const scrollToTop = () => window && window.scrollTo(0, 0);
